import { createEmptyObjectFromSchema } from "@Totum/Main/Utils";
import { IQuestionSchema } from "@Totum/QuestionnaireBuilder/Domain/schemas";
import { IQuestion } from "@Totum/QuestionnaireBuilder/Domain/types";

/**
 * Creates a new question based on the schema
 */
export const createNewQuestion = (questionnaireId: string): IQuestion => {
    return createEmptyObjectFromSchema(IQuestionSchema, {
        questionId: undefined,
        questionnaireId,
    });
};

export const isValidQuestionType = (type: string): type is IQuestion["questionType"] => {
    return IQuestionSchema.shape.questionType.safeParse(type).success;
};
